module.exports = __webpack_public_path__ + "static/media/Template_51.79b44bf5.png";